import React, { useState } from 'react';
import '../EditVendorModal/EditVendorModal.css';
import { Vendor } from '../../types/vendor'; 
type VendorCreationData = Omit<Vendor, 'id' | 'createdAt' | 'updatedAt'>;

interface AddVendorModalProps {
  onClose: () => void;
  onSave: (newVendor: VendorCreationData) => void;
  isSaving: boolean;
}

const AddVendorModal: React.FC<AddVendorModalProps> = ({ onClose, onSave, isSaving }) => {
  const [formData, setFormData] = useState<VendorCreationData>({
    name: '',
    email: '',
    phone: '',
    address: '',
    description: '',
    logo: '',
    isActive: true,  
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };
 
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Add New Vendor</h2>
        <form onSubmit={handleSubmit}>
          {/* ... all form-group divs are unchanged ... */}
          <div className="form-group">
            <label htmlFor="name">Vendor Name</label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="address">Address</label>
            <textarea id="address" name="address" value={formData.address} onChange={handleChange} rows={3} required></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea id="description" name="description" value={formData.description} onChange={handleChange} rows={3}></textarea>
          </div>
          
          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? 'Creating...' : 'Create Vendor'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddVendorModal;